import { render, staticRenderFns } from "./MatchProgressSection.vue?vue&type=template&id=5686bfa4&scoped=true"
import script from "./MatchProgressSection.vue?vue&type=script&lang=js"
export * from "./MatchProgressSection.vue?vue&type=script&lang=js"
import style0 from "./MatchProgressSection.vue?vue&type=style&index=0&id=5686bfa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686bfa4",
  null
  
)

export default component.exports